export enum AanvraagGAStatus {
  Created = 201,
  InProgress = 102,
  Processed = 202,
  NeedsInfo = 206,
  NotFound = 404,
  Cancelled = 409,
}
